import { useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';

import OrderAlertModal from '../OrderAlertModal/OrderAlertModal';
import TimeSlotModal from '../TimeSlotModal/TimeSlotModal';

import styles from './TimeSlotsMobile.module.scss';

export default function TimeSlotsMobile({
  selectedDay,
  onChangeSelectDay,
  selectOptionsDays,
  selectedTime,
  onChangeSelectTimeslot,
  selectOptionsSlotsByDay,
}) {
  const [isDaySlotVisible, setIsDaySlotVisible] = useState(false);
  const [isTimeSlotVisible, setIsTimeSlotVisible] = useState(false);
  const [dayError, setDayError] = useState(null);

  function showTimeSlotDialog() {
    if (selectedDay) {
      setIsTimeSlotVisible(true);
      return;
    }
    setDayError(true);
  }

  return (
    <section>
      <button type="button" className={styles.slotButton} onClick={() => setIsDaySlotVisible(true)}>
        <span>{selectedDay ? selectedDay.label : 'Επίλεξε ημέρα παράδοσης'}</span>
        <MdKeyboardArrowDown className={styles.arrowIcon} />
      </button>
      <button type="button" className={styles.slotButton} onClick={showTimeSlotDialog}>
        <span>{selectedTime ? selectedTime.label : 'Επίλεξε ώρα παράδοσης'}</span>
        <MdKeyboardArrowDown className={styles.arrowIcon} />
      </button>
      <TimeSlotModal
        title="Επίλεξε ημέρα παράδοσης"
        isOpen={isDaySlotVisible}
        setIsOpen={setIsDaySlotVisible}
        options={selectOptionsDays}
        selectedOption={selectedDay}
        onSelect={onChangeSelectDay}
      />
      <TimeSlotModal
        title="Επίλεξε ώρα παράδοσης"
        isOpen={isTimeSlotVisible}
        setIsOpen={setIsTimeSlotVisible}
        options={selectOptionsSlotsByDay}
        selectedOption={selectedTime}
        onSelect={onChangeSelectTimeslot}
      />
      {dayError && (
        <OrderAlertModal
          alertText="Παρακαλώ επιλέξτε πρώτα ημέρα παράδοσης"
          isModalOpen={dayError !== null}
          callback={() => {
            setDayError(null);
          }}
        />
      )}
    </section>
  );
}
